<div class="gradient-layout">
    <div class="container blurred-container">
        <div class="card">
            <div class="card-body" style="height: 82vh; overflow-y: scroll;">
                <div class="header">
                    <h1>Pixel Match</h1>
                    <h2>
                        Pixel Match tiene la finalidad de ayudarte a reconstruir tu archivo zip para tus campañas.
                    </h2>
                    <ol>
                        <li>Selecciona el tipo de campaña</li>
                        <li>Escribe el nombre que tendrá</li>
                        <li>Carga tu archivo zip con las imágenes</li>
                    </ol>
                    <h2>
                        Después de estos pasos, se evaluará el contenido del archivo y:
                    </h2>
                    <ul>
                        <li>Si hay una imagen faltante se te notificará qué dimensiones debe tener</li>
                        <li>Si hay imágenes extras al tipo de campaña, serán descartadas</li>
                        <li>Regresa el archivo renombrado así como las imágenes renombradas también</li>
                    </ul>
                </div>

                <ng-container>
                    <mat-horizontal-stepper linear="true" #stepper (selectionChange)="onStepChange()">
                        <ng-template matStepperIcon="edit">
                            <i class="fas fa-pen"></i>
                        </ng-template>
                        <ng-template matStepperIcon="done">
                            <i class="fas fa-check"></i>
                        </ng-template>


                        <mat-step label="Configuración" [stepControl]="imgZipperForm">
                            <ng-container>
                                <div class="mt-4 align-items-center">
                                    <form [formGroup]="imgZipperForm" enctype="multipart/form-data">

                                        <div class="row">
                                            <!-- Nombre de Campaña -->
                                            <div class="col-12 col-lg-6 mb-3">
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Nombre de Campaña</mat-label>
                                                    <input matInput formControlName="campaignName" autocomplete="off" />
                                                </mat-form-field>
                                            </div>

                                            <!-- Tipo de Campaña -->
                                            <div class="col-12 col-lg-6 mb-3">
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Tipo de campaña</mat-label>
                                                    <mat-select formControlName="campaignType" required>
                                                        <mat-option *ngFor="let ct of campaingTypes" [value]="ct">
                                                            {{ ct }}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                        </div>

                                        <div class="row mt-4">
                                            <!-- Archivo -->
                                            <div class="col-12 col-lg-6 mb-3">
                                                <input type="file" class="file-input" accept=".zip"
                                                    (change)="onFileSelected($event)" #fileUpload hidden>

                                                <div class="file-upload">
                                                    {{fileName || ""}}
                                                    <button mat-stroked-button color="primary" class="upload-btn"
                                                        (click)="fileUpload.click()">
                                                        <mat-icon>Elegir archivo ZIP</mat-icon>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="text-right mt-4">
                                            <button mat-button matStepperNext color="primary"
                                                [disabled]="!imgZipperForm?.valid">
                                                Siguiente
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </ng-container>
                        </mat-step>

                        <mat-step label="Resumen">
                            <div class="row">
                                <div class="col-12 col-lg-6 mb-2">
                                    <h3><b>Nombre de la Campaña:</b> {{imgZipperForm.value.campaignName}}
                                    </h3>
                                </div>
                                <div class="col-12 col-lg-6 mb-2">
                                    <h3><b>Tipo de Campaña:</b> {{imgZipperForm.value.campaignType}}</h3>
                                </div>
                            </div>

                            <div class="d-flex flex-column align-items-center">
                                <ng-container *ngIf="matchedZip.reqStatus === 1 || matchInfo.reqStatus === 1">
                                    <mat-spinner></mat-spinner>
                                    <span class="mt-4">Evaluando archivo...</span>
                                </ng-container>

                                <ng-container *ngIf="matchedZip.reqStatus === 2">
                                    <i class="far fa-check-circle text-success"></i>
                                    <span class="mt-4">
                                        Archivo generado
                                    </span>
                                </ng-container>

                                <ng-container *ngIf="matchedZip.reqStatus === 3">
                                    <i class="far fa-times-circle text-danger"></i>
                                    <span class="mt-4">
                                        No fue posible generar el archivo, revisa el contenido de tu zip.
                                    </span>
                                </ng-container>

                                <ng-container *ngIf="matchInfo.reqStatus === 3">
                                    <i class="far fa-times-circle text-danger"></i>
                                    <span class="mt-4">
                                        {{matchInfo.errMsg}}
                                    </span>
                                    <button class="mt-2" mat-button color="primary" (click)="getMatchInfo()">
                                        Reintentar
                                    </button>
                                </ng-container>
                            </div>

                            <div class="row mt-3">
                                <div class="col-12 col-lg-12">
                                    <div class="mb-5">
                                        <ng-container>
                                            <ng-container *ngIf="matchInfo.reqStatus === 2">
                                                <div class="items-container">
                                                    <mat-card *ngFor="let file of matchInfo.data.result"
                                                        class="item-card">
                                                        <div class="d-flex align-items-center">
                                                            <mat-icon class="mr-2">
                                                                <i class="fas fa-file"></i>
                                                            </mat-icon>
                                                            <div class="text-muted">
                                                                <h4 class="mb-0">{{ file.file_name }}</h4>
                                                            </div>
                                                        </div>
                                                        <div class="mt-3">
                                                            <mat-hint *ngIf="file.result === 'Correcto'">
                                                                <i class="far fa-check-circle text-success"></i>
                                                                {{file.result}}
                                                            </mat-hint>
                                                            <mat-error *ngIf="file.result !== 'Correcto'">
                                                                <i class="far fa-times-circle text-danger"></i>
                                                                {{file.result}}
                                                            </mat-error>
                                                        </div>
                                                        <div class="row mt-3">
                                                            <div
                                                                class="item-name text-muted mt-0 col-12 col-lg-12 mb-0">
                                                                <p><b>Ancho:</b> {{file.width}}px</p>
                                                            </div>
                                                            <div
                                                                class="item-name text-muted mt-0 col-12 col-lg-12 mb-0">
                                                                <p><b>Alto:</b> {{file.height}}px</p>
                                                            </div>
                                                        </div>
                                                    </mat-card>
                                                </div>
                                            </ng-container>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </mat-step>
                    </mat-horizontal-stepper>
                </ng-container>
            </div>
        </div>
    </div>
</div>